//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Onboarding.Training',
                {
                    url: '/Training',
                    component: 'trainingComponent',
                });
        }
    ]);

    app.component('trainingComponent', {
        templateUrl: 'App.Onboarding/States/Training/Training.template.html',
        controller: 'TrainingController',
        bindings: {
            user: '<',
            userGroup: '<',
            onBehalfOfUserGroup: '<',
        }
    });

    app.controller('TrainingController', TrainingController);

    TrainingController.$inject = ['trainingConstant', 'carrierReportsApi'];

    function TrainingController(trainingConstant, carrierReportsApi) {
        var $ctrl = this;
        ng.extend($ctrl, {
            ui: {
                loading: false
            }
        });
        function getCarrierTraining() {
            $ctrl.ui.loading = true;
            carrierReportsApi.getCarrierTraining()
                .then(function (response) {
                    $ctrl.carrierTraining = response;
                })
                .finally(function () {
                    $ctrl.ui.loading = false;
                });
        }

        $ctrl.$onInit = function () {
            getCarrierTraining();
            $ctrl.generalTraining = trainingConstant.GeneralTraining;
        };
    }
})(window.angular, window.app);